import React from 'react';

import './index.less';
import IbTypography from '../../../../../components/common/IbTypography';
import IbIcon from '../../../../../components/common/IbIcon';
import { getTranslateFunc } from '../../../../../utils/stringUtil';
import { Auth } from '../../../../../../gamma-api';
import IbTooltip from '../../../../../components/common/IbTooltip';

import { MAIN_CLASS_NAME, COLUMN_CLASS_NAME, COLUMN_TITLE_CLASS_NAME } from './const';

export interface IToolsetInfoBarProps {
  url: string;
  name: string;
  auth: Auth;
}

const ToolsetInfoBar: React.FC<IToolsetInfoBarProps> = ({ url, name, auth }) => {
  const translate = getTranslateFunc('Toolkits: ELMA365: Toolset: ToolInfoBar:');

  return (
    <div className={MAIN_CLASS_NAME}>
      <div className={`${COLUMN_CLASS_NAME} ${COLUMN_TITLE_CLASS_NAME}`}>
        <IbIcon iconName="elma365" size={20} />
        <IbTypography.Paragraph strong type="secondary">
          {translate('Title')}
        </IbTypography.Paragraph>
      </div>
      <div className={COLUMN_CLASS_NAME}>
        <IbTypography.Paragraph disabled type="secondary">
          {translate('Name')}
        </IbTypography.Paragraph>
        <IbTooltip title={name}>
          <IbTypography.Paragraph ellipsis>{name}</IbTypography.Paragraph>
        </IbTooltip>
      </div>
      <div className={COLUMN_CLASS_NAME}>
        <IbTypography.Paragraph disabled type="secondary">
          {translate('URL')}
        </IbTypography.Paragraph>
        <IbTooltip title={url}>
          <IbTypography.Paragraph ellipsis>{url}</IbTypography.Paragraph>
        </IbTooltip>
      </div>
      <div className={COLUMN_CLASS_NAME}>
        <IbTypography.Paragraph disabled type="secondary">
          {translate('Auth: Title')}
        </IbTypography.Paragraph>
        <IbTooltip title={auth.type}>
          <IbTypography.Paragraph ellipsis>{translate(`Auth: ${auth.type}`)}</IbTypography.Paragraph>
        </IbTooltip>
      </div>
    </div>
  );
};

export default ToolsetInfoBar;
